/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectProjectRouteRouteImport } from './routes/project.$project/route'
import { Route as ProjectProjectIndexRouteImport } from './routes/project.$project/index'
import { Route as OrganizationOrgIndexRouteImport } from './routes/organization.$org/index'
import { Route as OrganizationOrgApiDocsRouteImport } from './routes/organization.$org/api-docs'
import { Route as OrganizationOrgGuidesGuideRouteImport } from './routes/organization.$org/guides.$guide'
import { Route as userMgmtProjectProjectUserMgmtGuideRouteImport } from './routes/(user-mgmt)/project.$project.user-mgmt-guide'
import { Route as userMgmtProjectProjectUserMgmtRouteImport } from './routes/(user-mgmt)/project.$project.user-mgmt'
import { Route as userMgmtOrganizationOrgUserMgmtGuideRouteImport } from './routes/(user-mgmt)/organization.$org.user-mgmt-guide'
import { Route as userMgmtOrganizationOrgUserMgmtRouteImport } from './routes/(user-mgmt)/organization.$org.user-mgmt'
import { Route as ProjectProjectinvoicesInvoicesIndexRouteImport } from './routes/project.$project/(invoices)/invoices.index'
import { Route as ProjectProjectdeclarationsDeclarationsIndexRouteImport } from './routes/project.$project/(declarations)/declarations.index'
import { Route as ProjectProjectcertificatesCertificatesIndexRouteImport } from './routes/project.$project/(certificates)/certificates.index'
import { Route as ProjectProjectcargoesCargoesIndexRouteImport } from './routes/project.$project/(cargoes)/cargoes.index'
import { Route as userMgmtProjectProjectUserMgmtIndexRouteImport } from './routes/(user-mgmt)/project.$project.user-mgmt.index'
import { Route as userMgmtOrganizationOrgUserMgmtIndexRouteImport } from './routes/(user-mgmt)/organization.$org.user-mgmt.index'
import { Route as ProjectProjectinvoicesInvoicesInvoiceRouteImport } from './routes/project.$project/(invoices)/invoices.$invoice'
import { Route as ProjectProjectdeclarationsDeclarationsDeclarationRouteImport } from './routes/project.$project/(declarations)/declarations.$declaration'
import { Route as ProjectProjectcompositionAdminCompositionSetupRouteImport } from './routes/project.$project/(composition-admin)/composition.setup'
import { Route as ProjectProjectcertificatesCertificatesCertRouteImport } from './routes/project.$project/(certificates)/certificates.$cert'
import { Route as ProjectProjectcargoesCargoesCargoRouteImport } from './routes/project.$project/(cargoes)/cargoes.$cargo'
import { Route as userMgmtProjectProjectUserMgmtUsersRouteImport } from './routes/(user-mgmt)/project.$project.user-mgmt.users'
import { Route as userMgmtProjectProjectUserMgmtServiceAccountsRouteImport } from './routes/(user-mgmt)/project.$project.user-mgmt.service-accounts'
import { Route as userMgmtProjectProjectUserMgmtRolesRouteImport } from './routes/(user-mgmt)/project.$project.user-mgmt.roles'
import { Route as userMgmtOrganizationOrgUserMgmtUsersRouteImport } from './routes/(user-mgmt)/organization.$org.user-mgmt.users'
import { Route as userMgmtOrganizationOrgUserMgmtServiceAccountsRouteImport } from './routes/(user-mgmt)/organization.$org.user-mgmt.service-accounts'
import { Route as userMgmtOrganizationOrgUserMgmtRolesRouteImport } from './routes/(user-mgmt)/organization.$org.user-mgmt.roles'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectRouteRoute = ProjectProjectRouteRouteImport.update({
  id: '/project/$project',
  path: '/project/$project',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIndexRoute = ProjectProjectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectProjectRouteRoute,
} as any)
const OrganizationOrgIndexRoute = OrganizationOrgIndexRouteImport.update({
  id: '/organization/$org/',
  path: '/organization/$org/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationOrgApiDocsRoute = OrganizationOrgApiDocsRouteImport.update({
  id: '/organization/$org/api-docs',
  path: '/organization/$org/api-docs',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationOrgGuidesGuideRoute =
  OrganizationOrgGuidesGuideRouteImport.update({
    id: '/organization/$org/guides/$guide',
    path: '/organization/$org/guides/$guide',
    getParentRoute: () => rootRouteImport,
  } as any)
const userMgmtProjectProjectUserMgmtGuideRoute =
  userMgmtProjectProjectUserMgmtGuideRouteImport.update({
    id: '/(user-mgmt)/project/$project/user-mgmt-guide',
    path: '/project/$project/user-mgmt-guide',
    getParentRoute: () => rootRouteImport,
  } as any)
const userMgmtProjectProjectUserMgmtRoute =
  userMgmtProjectProjectUserMgmtRouteImport.update({
    id: '/(user-mgmt)/project/$project/user-mgmt',
    path: '/project/$project/user-mgmt',
    getParentRoute: () => rootRouteImport,
  } as any)
const userMgmtOrganizationOrgUserMgmtGuideRoute =
  userMgmtOrganizationOrgUserMgmtGuideRouteImport.update({
    id: '/(user-mgmt)/organization/$org/user-mgmt-guide',
    path: '/organization/$org/user-mgmt-guide',
    getParentRoute: () => rootRouteImport,
  } as any)
const userMgmtOrganizationOrgUserMgmtRoute =
  userMgmtOrganizationOrgUserMgmtRouteImport.update({
    id: '/(user-mgmt)/organization/$org/user-mgmt',
    path: '/organization/$org/user-mgmt',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectProjectinvoicesInvoicesIndexRoute =
  ProjectProjectinvoicesInvoicesIndexRouteImport.update({
    id: '/(invoices)/invoices/',
    path: '/invoices/',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectdeclarationsDeclarationsIndexRoute =
  ProjectProjectdeclarationsDeclarationsIndexRouteImport.update({
    id: '/(declarations)/declarations/',
    path: '/declarations/',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectcertificatesCertificatesIndexRoute =
  ProjectProjectcertificatesCertificatesIndexRouteImport.update({
    id: '/(certificates)/certificates/',
    path: '/certificates/',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectcargoesCargoesIndexRoute =
  ProjectProjectcargoesCargoesIndexRouteImport.update({
    id: '/(cargoes)/cargoes/',
    path: '/cargoes/',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const userMgmtProjectProjectUserMgmtIndexRoute =
  userMgmtProjectProjectUserMgmtIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => userMgmtProjectProjectUserMgmtRoute,
  } as any)
const userMgmtOrganizationOrgUserMgmtIndexRoute =
  userMgmtOrganizationOrgUserMgmtIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => userMgmtOrganizationOrgUserMgmtRoute,
  } as any)
const ProjectProjectinvoicesInvoicesInvoiceRoute =
  ProjectProjectinvoicesInvoicesInvoiceRouteImport.update({
    id: '/(invoices)/invoices/$invoice',
    path: '/invoices/$invoice',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectdeclarationsDeclarationsDeclarationRoute =
  ProjectProjectdeclarationsDeclarationsDeclarationRouteImport.update({
    id: '/(declarations)/declarations/$declaration',
    path: '/declarations/$declaration',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectcompositionAdminCompositionSetupRoute =
  ProjectProjectcompositionAdminCompositionSetupRouteImport.update({
    id: '/(composition-admin)/composition/setup',
    path: '/composition/setup',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectcertificatesCertificatesCertRoute =
  ProjectProjectcertificatesCertificatesCertRouteImport.update({
    id: '/(certificates)/certificates/$cert',
    path: '/certificates/$cert',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const ProjectProjectcargoesCargoesCargoRoute =
  ProjectProjectcargoesCargoesCargoRouteImport.update({
    id: '/(cargoes)/cargoes/$cargo',
    path: '/cargoes/$cargo',
    getParentRoute: () => ProjectProjectRouteRoute,
  } as any)
const userMgmtProjectProjectUserMgmtUsersRoute =
  userMgmtProjectProjectUserMgmtUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => userMgmtProjectProjectUserMgmtRoute,
  } as any)
const userMgmtProjectProjectUserMgmtServiceAccountsRoute =
  userMgmtProjectProjectUserMgmtServiceAccountsRouteImport.update({
    id: '/service-accounts',
    path: '/service-accounts',
    getParentRoute: () => userMgmtProjectProjectUserMgmtRoute,
  } as any)
const userMgmtProjectProjectUserMgmtRolesRoute =
  userMgmtProjectProjectUserMgmtRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => userMgmtProjectProjectUserMgmtRoute,
  } as any)
const userMgmtOrganizationOrgUserMgmtUsersRoute =
  userMgmtOrganizationOrgUserMgmtUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => userMgmtOrganizationOrgUserMgmtRoute,
  } as any)
const userMgmtOrganizationOrgUserMgmtServiceAccountsRoute =
  userMgmtOrganizationOrgUserMgmtServiceAccountsRouteImport.update({
    id: '/service-accounts',
    path: '/service-accounts',
    getParentRoute: () => userMgmtOrganizationOrgUserMgmtRoute,
  } as any)
const userMgmtOrganizationOrgUserMgmtRolesRoute =
  userMgmtOrganizationOrgUserMgmtRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => userMgmtOrganizationOrgUserMgmtRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/project/$project': typeof ProjectProjectRouteRouteWithChildren
  '/organization/$org/api-docs': typeof OrganizationOrgApiDocsRoute
  '/organization/$org/': typeof OrganizationOrgIndexRoute
  '/project/$project/': typeof ProjectProjectIndexRoute
  '/organization/$org/user-mgmt': typeof userMgmtOrganizationOrgUserMgmtRouteWithChildren
  '/organization/$org/user-mgmt-guide': typeof userMgmtOrganizationOrgUserMgmtGuideRoute
  '/project/$project/user-mgmt': typeof userMgmtProjectProjectUserMgmtRouteWithChildren
  '/project/$project/user-mgmt-guide': typeof userMgmtProjectProjectUserMgmtGuideRoute
  '/organization/$org/guides/$guide': typeof OrganizationOrgGuidesGuideRoute
  '/organization/$org/user-mgmt/roles': typeof userMgmtOrganizationOrgUserMgmtRolesRoute
  '/organization/$org/user-mgmt/service-accounts': typeof userMgmtOrganizationOrgUserMgmtServiceAccountsRoute
  '/organization/$org/user-mgmt/users': typeof userMgmtOrganizationOrgUserMgmtUsersRoute
  '/project/$project/user-mgmt/roles': typeof userMgmtProjectProjectUserMgmtRolesRoute
  '/project/$project/user-mgmt/service-accounts': typeof userMgmtProjectProjectUserMgmtServiceAccountsRoute
  '/project/$project/user-mgmt/users': typeof userMgmtProjectProjectUserMgmtUsersRoute
  '/project/$project/cargoes/$cargo': typeof ProjectProjectcargoesCargoesCargoRoute
  '/project/$project/certificates/$cert': typeof ProjectProjectcertificatesCertificatesCertRoute
  '/project/$project/composition/setup': typeof ProjectProjectcompositionAdminCompositionSetupRoute
  '/project/$project/declarations/$declaration': typeof ProjectProjectdeclarationsDeclarationsDeclarationRoute
  '/project/$project/invoices/$invoice': typeof ProjectProjectinvoicesInvoicesInvoiceRoute
  '/organization/$org/user-mgmt/': typeof userMgmtOrganizationOrgUserMgmtIndexRoute
  '/project/$project/user-mgmt/': typeof userMgmtProjectProjectUserMgmtIndexRoute
  '/project/$project/cargoes/': typeof ProjectProjectcargoesCargoesIndexRoute
  '/project/$project/certificates/': typeof ProjectProjectcertificatesCertificatesIndexRoute
  '/project/$project/declarations/': typeof ProjectProjectdeclarationsDeclarationsIndexRoute
  '/project/$project/invoices/': typeof ProjectProjectinvoicesInvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/organization/$org/api-docs': typeof OrganizationOrgApiDocsRoute
  '/organization/$org': typeof OrganizationOrgIndexRoute
  '/project/$project': typeof ProjectProjectIndexRoute
  '/organization/$org/user-mgmt-guide': typeof userMgmtOrganizationOrgUserMgmtGuideRoute
  '/project/$project/user-mgmt-guide': typeof userMgmtProjectProjectUserMgmtGuideRoute
  '/organization/$org/guides/$guide': typeof OrganizationOrgGuidesGuideRoute
  '/organization/$org/user-mgmt/roles': typeof userMgmtOrganizationOrgUserMgmtRolesRoute
  '/organization/$org/user-mgmt/service-accounts': typeof userMgmtOrganizationOrgUserMgmtServiceAccountsRoute
  '/organization/$org/user-mgmt/users': typeof userMgmtOrganizationOrgUserMgmtUsersRoute
  '/project/$project/user-mgmt/roles': typeof userMgmtProjectProjectUserMgmtRolesRoute
  '/project/$project/user-mgmt/service-accounts': typeof userMgmtProjectProjectUserMgmtServiceAccountsRoute
  '/project/$project/user-mgmt/users': typeof userMgmtProjectProjectUserMgmtUsersRoute
  '/project/$project/cargoes/$cargo': typeof ProjectProjectcargoesCargoesCargoRoute
  '/project/$project/certificates/$cert': typeof ProjectProjectcertificatesCertificatesCertRoute
  '/project/$project/composition/setup': typeof ProjectProjectcompositionAdminCompositionSetupRoute
  '/project/$project/declarations/$declaration': typeof ProjectProjectdeclarationsDeclarationsDeclarationRoute
  '/project/$project/invoices/$invoice': typeof ProjectProjectinvoicesInvoicesInvoiceRoute
  '/organization/$org/user-mgmt': typeof userMgmtOrganizationOrgUserMgmtIndexRoute
  '/project/$project/user-mgmt': typeof userMgmtProjectProjectUserMgmtIndexRoute
  '/project/$project/cargoes': typeof ProjectProjectcargoesCargoesIndexRoute
  '/project/$project/certificates': typeof ProjectProjectcertificatesCertificatesIndexRoute
  '/project/$project/declarations': typeof ProjectProjectdeclarationsDeclarationsIndexRoute
  '/project/$project/invoices': typeof ProjectProjectinvoicesInvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/project/$project': typeof ProjectProjectRouteRouteWithChildren
  '/organization/$org/api-docs': typeof OrganizationOrgApiDocsRoute
  '/organization/$org/': typeof OrganizationOrgIndexRoute
  '/project/$project/': typeof ProjectProjectIndexRoute
  '/(user-mgmt)/organization/$org/user-mgmt': typeof userMgmtOrganizationOrgUserMgmtRouteWithChildren
  '/(user-mgmt)/organization/$org/user-mgmt-guide': typeof userMgmtOrganizationOrgUserMgmtGuideRoute
  '/(user-mgmt)/project/$project/user-mgmt': typeof userMgmtProjectProjectUserMgmtRouteWithChildren
  '/(user-mgmt)/project/$project/user-mgmt-guide': typeof userMgmtProjectProjectUserMgmtGuideRoute
  '/organization/$org/guides/$guide': typeof OrganizationOrgGuidesGuideRoute
  '/(user-mgmt)/organization/$org/user-mgmt/roles': typeof userMgmtOrganizationOrgUserMgmtRolesRoute
  '/(user-mgmt)/organization/$org/user-mgmt/service-accounts': typeof userMgmtOrganizationOrgUserMgmtServiceAccountsRoute
  '/(user-mgmt)/organization/$org/user-mgmt/users': typeof userMgmtOrganizationOrgUserMgmtUsersRoute
  '/(user-mgmt)/project/$project/user-mgmt/roles': typeof userMgmtProjectProjectUserMgmtRolesRoute
  '/(user-mgmt)/project/$project/user-mgmt/service-accounts': typeof userMgmtProjectProjectUserMgmtServiceAccountsRoute
  '/(user-mgmt)/project/$project/user-mgmt/users': typeof userMgmtProjectProjectUserMgmtUsersRoute
  '/project/$project/(cargoes)/cargoes/$cargo': typeof ProjectProjectcargoesCargoesCargoRoute
  '/project/$project/(certificates)/certificates/$cert': typeof ProjectProjectcertificatesCertificatesCertRoute
  '/project/$project/(composition-admin)/composition/setup': typeof ProjectProjectcompositionAdminCompositionSetupRoute
  '/project/$project/(declarations)/declarations/$declaration': typeof ProjectProjectdeclarationsDeclarationsDeclarationRoute
  '/project/$project/(invoices)/invoices/$invoice': typeof ProjectProjectinvoicesInvoicesInvoiceRoute
  '/(user-mgmt)/organization/$org/user-mgmt/': typeof userMgmtOrganizationOrgUserMgmtIndexRoute
  '/(user-mgmt)/project/$project/user-mgmt/': typeof userMgmtProjectProjectUserMgmtIndexRoute
  '/project/$project/(cargoes)/cargoes/': typeof ProjectProjectcargoesCargoesIndexRoute
  '/project/$project/(certificates)/certificates/': typeof ProjectProjectcertificatesCertificatesIndexRoute
  '/project/$project/(declarations)/declarations/': typeof ProjectProjectdeclarationsDeclarationsIndexRoute
  '/project/$project/(invoices)/invoices/': typeof ProjectProjectinvoicesInvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/project/$project'
    | '/organization/$org/api-docs'
    | '/organization/$org/'
    | '/project/$project/'
    | '/organization/$org/user-mgmt'
    | '/organization/$org/user-mgmt-guide'
    | '/project/$project/user-mgmt'
    | '/project/$project/user-mgmt-guide'
    | '/organization/$org/guides/$guide'
    | '/organization/$org/user-mgmt/roles'
    | '/organization/$org/user-mgmt/service-accounts'
    | '/organization/$org/user-mgmt/users'
    | '/project/$project/user-mgmt/roles'
    | '/project/$project/user-mgmt/service-accounts'
    | '/project/$project/user-mgmt/users'
    | '/project/$project/cargoes/$cargo'
    | '/project/$project/certificates/$cert'
    | '/project/$project/composition/setup'
    | '/project/$project/declarations/$declaration'
    | '/project/$project/invoices/$invoice'
    | '/organization/$org/user-mgmt/'
    | '/project/$project/user-mgmt/'
    | '/project/$project/cargoes/'
    | '/project/$project/certificates/'
    | '/project/$project/declarations/'
    | '/project/$project/invoices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/organization/$org/api-docs'
    | '/organization/$org'
    | '/project/$project'
    | '/organization/$org/user-mgmt-guide'
    | '/project/$project/user-mgmt-guide'
    | '/organization/$org/guides/$guide'
    | '/organization/$org/user-mgmt/roles'
    | '/organization/$org/user-mgmt/service-accounts'
    | '/organization/$org/user-mgmt/users'
    | '/project/$project/user-mgmt/roles'
    | '/project/$project/user-mgmt/service-accounts'
    | '/project/$project/user-mgmt/users'
    | '/project/$project/cargoes/$cargo'
    | '/project/$project/certificates/$cert'
    | '/project/$project/composition/setup'
    | '/project/$project/declarations/$declaration'
    | '/project/$project/invoices/$invoice'
    | '/organization/$org/user-mgmt'
    | '/project/$project/user-mgmt'
    | '/project/$project/cargoes'
    | '/project/$project/certificates'
    | '/project/$project/declarations'
    | '/project/$project/invoices'
  id:
    | '__root__'
    | '/'
    | '/project/$project'
    | '/organization/$org/api-docs'
    | '/organization/$org/'
    | '/project/$project/'
    | '/(user-mgmt)/organization/$org/user-mgmt'
    | '/(user-mgmt)/organization/$org/user-mgmt-guide'
    | '/(user-mgmt)/project/$project/user-mgmt'
    | '/(user-mgmt)/project/$project/user-mgmt-guide'
    | '/organization/$org/guides/$guide'
    | '/(user-mgmt)/organization/$org/user-mgmt/roles'
    | '/(user-mgmt)/organization/$org/user-mgmt/service-accounts'
    | '/(user-mgmt)/organization/$org/user-mgmt/users'
    | '/(user-mgmt)/project/$project/user-mgmt/roles'
    | '/(user-mgmt)/project/$project/user-mgmt/service-accounts'
    | '/(user-mgmt)/project/$project/user-mgmt/users'
    | '/project/$project/(cargoes)/cargoes/$cargo'
    | '/project/$project/(certificates)/certificates/$cert'
    | '/project/$project/(composition-admin)/composition/setup'
    | '/project/$project/(declarations)/declarations/$declaration'
    | '/project/$project/(invoices)/invoices/$invoice'
    | '/(user-mgmt)/organization/$org/user-mgmt/'
    | '/(user-mgmt)/project/$project/user-mgmt/'
    | '/project/$project/(cargoes)/cargoes/'
    | '/project/$project/(certificates)/certificates/'
    | '/project/$project/(declarations)/declarations/'
    | '/project/$project/(invoices)/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProjectProjectRouteRoute: typeof ProjectProjectRouteRouteWithChildren
  OrganizationOrgApiDocsRoute: typeof OrganizationOrgApiDocsRoute
  OrganizationOrgIndexRoute: typeof OrganizationOrgIndexRoute
  userMgmtOrganizationOrgUserMgmtRoute: typeof userMgmtOrganizationOrgUserMgmtRouteWithChildren
  userMgmtOrganizationOrgUserMgmtGuideRoute: typeof userMgmtOrganizationOrgUserMgmtGuideRoute
  userMgmtProjectProjectUserMgmtRoute: typeof userMgmtProjectProjectUserMgmtRouteWithChildren
  userMgmtProjectProjectUserMgmtGuideRoute: typeof userMgmtProjectProjectUserMgmtGuideRoute
  OrganizationOrgGuidesGuideRoute: typeof OrganizationOrgGuidesGuideRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$project': {
      id: '/project/$project'
      path: '/project/$project'
      fullPath: '/project/$project'
      preLoaderRoute: typeof ProjectProjectRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$project/': {
      id: '/project/$project/'
      path: '/'
      fullPath: '/project/$project/'
      preLoaderRoute: typeof ProjectProjectIndexRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/organization/$org/': {
      id: '/organization/$org/'
      path: '/organization/$org'
      fullPath: '/organization/$org/'
      preLoaderRoute: typeof OrganizationOrgIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization/$org/api-docs': {
      id: '/organization/$org/api-docs'
      path: '/organization/$org/api-docs'
      fullPath: '/organization/$org/api-docs'
      preLoaderRoute: typeof OrganizationOrgApiDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization/$org/guides/$guide': {
      id: '/organization/$org/guides/$guide'
      path: '/organization/$org/guides/$guide'
      fullPath: '/organization/$org/guides/$guide'
      preLoaderRoute: typeof OrganizationOrgGuidesGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(user-mgmt)/project/$project/user-mgmt-guide': {
      id: '/(user-mgmt)/project/$project/user-mgmt-guide'
      path: '/project/$project/user-mgmt-guide'
      fullPath: '/project/$project/user-mgmt-guide'
      preLoaderRoute: typeof userMgmtProjectProjectUserMgmtGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(user-mgmt)/project/$project/user-mgmt': {
      id: '/(user-mgmt)/project/$project/user-mgmt'
      path: '/project/$project/user-mgmt'
      fullPath: '/project/$project/user-mgmt'
      preLoaderRoute: typeof userMgmtProjectProjectUserMgmtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(user-mgmt)/organization/$org/user-mgmt-guide': {
      id: '/(user-mgmt)/organization/$org/user-mgmt-guide'
      path: '/organization/$org/user-mgmt-guide'
      fullPath: '/organization/$org/user-mgmt-guide'
      preLoaderRoute: typeof userMgmtOrganizationOrgUserMgmtGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(user-mgmt)/organization/$org/user-mgmt': {
      id: '/(user-mgmt)/organization/$org/user-mgmt'
      path: '/organization/$org/user-mgmt'
      fullPath: '/organization/$org/user-mgmt'
      preLoaderRoute: typeof userMgmtOrganizationOrgUserMgmtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$project/(invoices)/invoices/': {
      id: '/project/$project/(invoices)/invoices/'
      path: '/invoices'
      fullPath: '/project/$project/invoices/'
      preLoaderRoute: typeof ProjectProjectinvoicesInvoicesIndexRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(declarations)/declarations/': {
      id: '/project/$project/(declarations)/declarations/'
      path: '/declarations'
      fullPath: '/project/$project/declarations/'
      preLoaderRoute: typeof ProjectProjectdeclarationsDeclarationsIndexRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(certificates)/certificates/': {
      id: '/project/$project/(certificates)/certificates/'
      path: '/certificates'
      fullPath: '/project/$project/certificates/'
      preLoaderRoute: typeof ProjectProjectcertificatesCertificatesIndexRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(cargoes)/cargoes/': {
      id: '/project/$project/(cargoes)/cargoes/'
      path: '/cargoes'
      fullPath: '/project/$project/cargoes/'
      preLoaderRoute: typeof ProjectProjectcargoesCargoesIndexRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/(user-mgmt)/project/$project/user-mgmt/': {
      id: '/(user-mgmt)/project/$project/user-mgmt/'
      path: '/'
      fullPath: '/project/$project/user-mgmt/'
      preLoaderRoute: typeof userMgmtProjectProjectUserMgmtIndexRouteImport
      parentRoute: typeof userMgmtProjectProjectUserMgmtRoute
    }
    '/(user-mgmt)/organization/$org/user-mgmt/': {
      id: '/(user-mgmt)/organization/$org/user-mgmt/'
      path: '/'
      fullPath: '/organization/$org/user-mgmt/'
      preLoaderRoute: typeof userMgmtOrganizationOrgUserMgmtIndexRouteImport
      parentRoute: typeof userMgmtOrganizationOrgUserMgmtRoute
    }
    '/project/$project/(invoices)/invoices/$invoice': {
      id: '/project/$project/(invoices)/invoices/$invoice'
      path: '/invoices/$invoice'
      fullPath: '/project/$project/invoices/$invoice'
      preLoaderRoute: typeof ProjectProjectinvoicesInvoicesInvoiceRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(declarations)/declarations/$declaration': {
      id: '/project/$project/(declarations)/declarations/$declaration'
      path: '/declarations/$declaration'
      fullPath: '/project/$project/declarations/$declaration'
      preLoaderRoute: typeof ProjectProjectdeclarationsDeclarationsDeclarationRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(composition-admin)/composition/setup': {
      id: '/project/$project/(composition-admin)/composition/setup'
      path: '/composition/setup'
      fullPath: '/project/$project/composition/setup'
      preLoaderRoute: typeof ProjectProjectcompositionAdminCompositionSetupRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(certificates)/certificates/$cert': {
      id: '/project/$project/(certificates)/certificates/$cert'
      path: '/certificates/$cert'
      fullPath: '/project/$project/certificates/$cert'
      preLoaderRoute: typeof ProjectProjectcertificatesCertificatesCertRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/project/$project/(cargoes)/cargoes/$cargo': {
      id: '/project/$project/(cargoes)/cargoes/$cargo'
      path: '/cargoes/$cargo'
      fullPath: '/project/$project/cargoes/$cargo'
      preLoaderRoute: typeof ProjectProjectcargoesCargoesCargoRouteImport
      parentRoute: typeof ProjectProjectRouteRoute
    }
    '/(user-mgmt)/project/$project/user-mgmt/users': {
      id: '/(user-mgmt)/project/$project/user-mgmt/users'
      path: '/users'
      fullPath: '/project/$project/user-mgmt/users'
      preLoaderRoute: typeof userMgmtProjectProjectUserMgmtUsersRouteImport
      parentRoute: typeof userMgmtProjectProjectUserMgmtRoute
    }
    '/(user-mgmt)/project/$project/user-mgmt/service-accounts': {
      id: '/(user-mgmt)/project/$project/user-mgmt/service-accounts'
      path: '/service-accounts'
      fullPath: '/project/$project/user-mgmt/service-accounts'
      preLoaderRoute: typeof userMgmtProjectProjectUserMgmtServiceAccountsRouteImport
      parentRoute: typeof userMgmtProjectProjectUserMgmtRoute
    }
    '/(user-mgmt)/project/$project/user-mgmt/roles': {
      id: '/(user-mgmt)/project/$project/user-mgmt/roles'
      path: '/roles'
      fullPath: '/project/$project/user-mgmt/roles'
      preLoaderRoute: typeof userMgmtProjectProjectUserMgmtRolesRouteImport
      parentRoute: typeof userMgmtProjectProjectUserMgmtRoute
    }
    '/(user-mgmt)/organization/$org/user-mgmt/users': {
      id: '/(user-mgmt)/organization/$org/user-mgmt/users'
      path: '/users'
      fullPath: '/organization/$org/user-mgmt/users'
      preLoaderRoute: typeof userMgmtOrganizationOrgUserMgmtUsersRouteImport
      parentRoute: typeof userMgmtOrganizationOrgUserMgmtRoute
    }
    '/(user-mgmt)/organization/$org/user-mgmt/service-accounts': {
      id: '/(user-mgmt)/organization/$org/user-mgmt/service-accounts'
      path: '/service-accounts'
      fullPath: '/organization/$org/user-mgmt/service-accounts'
      preLoaderRoute: typeof userMgmtOrganizationOrgUserMgmtServiceAccountsRouteImport
      parentRoute: typeof userMgmtOrganizationOrgUserMgmtRoute
    }
    '/(user-mgmt)/organization/$org/user-mgmt/roles': {
      id: '/(user-mgmt)/organization/$org/user-mgmt/roles'
      path: '/roles'
      fullPath: '/organization/$org/user-mgmt/roles'
      preLoaderRoute: typeof userMgmtOrganizationOrgUserMgmtRolesRouteImport
      parentRoute: typeof userMgmtOrganizationOrgUserMgmtRoute
    }
  }
}

interface ProjectProjectRouteRouteChildren {
  ProjectProjectIndexRoute: typeof ProjectProjectIndexRoute
  ProjectProjectcargoesCargoesCargoRoute: typeof ProjectProjectcargoesCargoesCargoRoute
  ProjectProjectcertificatesCertificatesCertRoute: typeof ProjectProjectcertificatesCertificatesCertRoute
  ProjectProjectcompositionAdminCompositionSetupRoute: typeof ProjectProjectcompositionAdminCompositionSetupRoute
  ProjectProjectdeclarationsDeclarationsDeclarationRoute: typeof ProjectProjectdeclarationsDeclarationsDeclarationRoute
  ProjectProjectinvoicesInvoicesInvoiceRoute: typeof ProjectProjectinvoicesInvoicesInvoiceRoute
  ProjectProjectcargoesCargoesIndexRoute: typeof ProjectProjectcargoesCargoesIndexRoute
  ProjectProjectcertificatesCertificatesIndexRoute: typeof ProjectProjectcertificatesCertificatesIndexRoute
  ProjectProjectdeclarationsDeclarationsIndexRoute: typeof ProjectProjectdeclarationsDeclarationsIndexRoute
  ProjectProjectinvoicesInvoicesIndexRoute: typeof ProjectProjectinvoicesInvoicesIndexRoute
}

const ProjectProjectRouteRouteChildren: ProjectProjectRouteRouteChildren = {
  ProjectProjectIndexRoute: ProjectProjectIndexRoute,
  ProjectProjectcargoesCargoesCargoRoute:
    ProjectProjectcargoesCargoesCargoRoute,
  ProjectProjectcertificatesCertificatesCertRoute:
    ProjectProjectcertificatesCertificatesCertRoute,
  ProjectProjectcompositionAdminCompositionSetupRoute:
    ProjectProjectcompositionAdminCompositionSetupRoute,
  ProjectProjectdeclarationsDeclarationsDeclarationRoute:
    ProjectProjectdeclarationsDeclarationsDeclarationRoute,
  ProjectProjectinvoicesInvoicesInvoiceRoute:
    ProjectProjectinvoicesInvoicesInvoiceRoute,
  ProjectProjectcargoesCargoesIndexRoute:
    ProjectProjectcargoesCargoesIndexRoute,
  ProjectProjectcertificatesCertificatesIndexRoute:
    ProjectProjectcertificatesCertificatesIndexRoute,
  ProjectProjectdeclarationsDeclarationsIndexRoute:
    ProjectProjectdeclarationsDeclarationsIndexRoute,
  ProjectProjectinvoicesInvoicesIndexRoute:
    ProjectProjectinvoicesInvoicesIndexRoute,
}

const ProjectProjectRouteRouteWithChildren =
  ProjectProjectRouteRoute._addFileChildren(ProjectProjectRouteRouteChildren)

interface userMgmtOrganizationOrgUserMgmtRouteChildren {
  userMgmtOrganizationOrgUserMgmtRolesRoute: typeof userMgmtOrganizationOrgUserMgmtRolesRoute
  userMgmtOrganizationOrgUserMgmtServiceAccountsRoute: typeof userMgmtOrganizationOrgUserMgmtServiceAccountsRoute
  userMgmtOrganizationOrgUserMgmtUsersRoute: typeof userMgmtOrganizationOrgUserMgmtUsersRoute
  userMgmtOrganizationOrgUserMgmtIndexRoute: typeof userMgmtOrganizationOrgUserMgmtIndexRoute
}

const userMgmtOrganizationOrgUserMgmtRouteChildren: userMgmtOrganizationOrgUserMgmtRouteChildren =
  {
    userMgmtOrganizationOrgUserMgmtRolesRoute:
      userMgmtOrganizationOrgUserMgmtRolesRoute,
    userMgmtOrganizationOrgUserMgmtServiceAccountsRoute:
      userMgmtOrganizationOrgUserMgmtServiceAccountsRoute,
    userMgmtOrganizationOrgUserMgmtUsersRoute:
      userMgmtOrganizationOrgUserMgmtUsersRoute,
    userMgmtOrganizationOrgUserMgmtIndexRoute:
      userMgmtOrganizationOrgUserMgmtIndexRoute,
  }

const userMgmtOrganizationOrgUserMgmtRouteWithChildren =
  userMgmtOrganizationOrgUserMgmtRoute._addFileChildren(
    userMgmtOrganizationOrgUserMgmtRouteChildren,
  )

interface userMgmtProjectProjectUserMgmtRouteChildren {
  userMgmtProjectProjectUserMgmtRolesRoute: typeof userMgmtProjectProjectUserMgmtRolesRoute
  userMgmtProjectProjectUserMgmtServiceAccountsRoute: typeof userMgmtProjectProjectUserMgmtServiceAccountsRoute
  userMgmtProjectProjectUserMgmtUsersRoute: typeof userMgmtProjectProjectUserMgmtUsersRoute
  userMgmtProjectProjectUserMgmtIndexRoute: typeof userMgmtProjectProjectUserMgmtIndexRoute
}

const userMgmtProjectProjectUserMgmtRouteChildren: userMgmtProjectProjectUserMgmtRouteChildren =
  {
    userMgmtProjectProjectUserMgmtRolesRoute:
      userMgmtProjectProjectUserMgmtRolesRoute,
    userMgmtProjectProjectUserMgmtServiceAccountsRoute:
      userMgmtProjectProjectUserMgmtServiceAccountsRoute,
    userMgmtProjectProjectUserMgmtUsersRoute:
      userMgmtProjectProjectUserMgmtUsersRoute,
    userMgmtProjectProjectUserMgmtIndexRoute:
      userMgmtProjectProjectUserMgmtIndexRoute,
  }

const userMgmtProjectProjectUserMgmtRouteWithChildren =
  userMgmtProjectProjectUserMgmtRoute._addFileChildren(
    userMgmtProjectProjectUserMgmtRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProjectProjectRouteRoute: ProjectProjectRouteRouteWithChildren,
  OrganizationOrgApiDocsRoute: OrganizationOrgApiDocsRoute,
  OrganizationOrgIndexRoute: OrganizationOrgIndexRoute,
  userMgmtOrganizationOrgUserMgmtRoute:
    userMgmtOrganizationOrgUserMgmtRouteWithChildren,
  userMgmtOrganizationOrgUserMgmtGuideRoute:
    userMgmtOrganizationOrgUserMgmtGuideRoute,
  userMgmtProjectProjectUserMgmtRoute:
    userMgmtProjectProjectUserMgmtRouteWithChildren,
  userMgmtProjectProjectUserMgmtGuideRoute:
    userMgmtProjectProjectUserMgmtGuideRoute,
  OrganizationOrgGuidesGuideRoute: OrganizationOrgGuidesGuideRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
